<template>
  <customers-page
    ref="customersPage"
    :export-loading="exportLoading"
    @export-customers="getCsvReport"
    @get-customers="fetchData"
  />
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import CustomersPage from './CustomersPage';
import { downloadBlob } from '@/utils/download';
import { showNotification } from '@/utils/notifications';
import { getAndSyncQueryParams } from '@/utils/queryParams';

export default {
  components: {
    'customers-page': CustomersPage,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      exportLoading: false,
    };
  },
  computed: {
    customers() {
      return [...this.$store.state.customers.list].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
    params: {
      handler: 'fetchData',
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['getCustomers', 'getAllCustomersExportCsvReport']),
    getCsvReport() {
      this.exportLoading = true;
      this.getAllCustomersExportCsvReport(this.params)
        .then((response) => {
          downloadBlob(
            response.data,
            `Inscribe Customer Export ${moment().format('YYYY-MM-DD')}.csv`,
            'text/csv',
          );
          this.exportLoading = false;
        })
        .catch(() =>
          showNotification({ type: 'error', title: 'Error exporting CSV' }),
        );
    },

    async fetchData() {
      this.getCustomers(this.params).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.export_csv_button {
  margin-left: auto;
  cursor: pointer;
}
</style>
